
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/_DesignSystemWrapper",
      function () {
        return require("private-next-pages/design-system/_DesignSystemWrapper.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/_DesignSystemWrapper"])
      });
    }
  